import React from "react";
import { ReportPeriod } from "../types";
import { getPeriodLabel } from "../utils/periodUtils";

interface PeriodSelectorProps {
  selectedPeriod: ReportPeriod;
  onPeriodChange: (period: ReportPeriod) => void;
}

const periodOptions: ReportPeriod[] = [
  "week",
  "10days", 
  "2weeks",
  "month",
  "quarter",
  "half",
];

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  selectedPeriod,
  onPeriodChange,
}) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <label style={{ fontSize: "14px", fontWeight: 500 }}>Period:</label>
      <select
        value={selectedPeriod}
        onChange={(e) => onPeriodChange(e.target.value as ReportPeriod)}
        style={{
          padding: "8px 12px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          backgroundColor: "#fff",
          color: "#000",
          fontSize: "14px",
          cursor: "pointer",
          outline: "none",
          minWidth: "120px",
        }}
      >
        {periodOptions.map((period) => (
          <option key={period} value={period}>
            {getPeriodLabel(period)}
          </option>
        ))}
      </select>
    </div>
  );
};